// extracted by mini-css-extract-plugin
export default {"iframe-dialog--body":"_1JYIv9Rp4rberFFzVkLmWWd4EbZOa5kDT+EwP0pJlhc=","iframe-dialog--iframe":"bLZ3Aei6tM1ZuLWR1DghQ+5t-AY7V6mEBV8eVpuPvi0="};